<template>
  <div>
    <section>
      <div
        class="bookmark-bg2 container-fluid d-flex justify-content-center align-items-center"
      >
        <div class="text-center display-flex flex-column">
          <h3 class="t-black m-auto mb-1">ท่ามกลางความมืดมิด</h3>
          <h3 class="t-white m-auto mb-1">ก็ยังมีแสงแห่งความหวัง</h3>

          <div class="maintext text-center m-5">
            <h1 class="m-2">ในปี 2022</h1>
            <h1 class="m-2">คราฟต์เบียร์ไทยได้เข้าใกล้</h1>
            <h1 class="m-2">ความเปลี่ยนแปลงมากกว่าที่เคย</h1>
          </div>
          <vue-aos animation-class="slideInUp animated">
            <div class="hand m-auto">
              <img src="@/assets/pics/frame5/5/hands.svg" alt="" />
            </div>
          </vue-aos>
        </div>
      </div>

      <div
        class="bookmark-bg3 container-fluid d-flex justify-content-center align-items-center p-5"
      >
        <div class="text-center display-flex flex-column">
          <h1 class="text-color m-auto mb-2">พ.ร.บ. สุราก้าวหน้า</h1>
          <h3 class="mb-5">หมุดหมายสำคัญของวงการคราฟต์เบียร์</h3>
          <p class="b5">คอนเซปต์ของพ.ร.บ.สุราก้าวหน้า คือ</p>

          <div class="part2 d-flex flex-column">
            <img
              src="@/assets/pics/frame4/4.6/top.svg"
              class="mt-lg-5 mb-lg-5 mt-4 mb-4"
            />
            <h1>
              ยกเลิกกฎหมายที่เป็นอุปสรรคต่อการผลิตสุรา <br />
              หรือขัดขวางไม่ให้ประชาชนประกอบอาชีพผลิตสุราได้อย่างเสรี
            </h1>
            <img
              src="@/assets/pics/frame4/4.6/bot.svg"
              class="mt-lg-5 mb-lg-5 mt-4 mb-4"
            />
          </div>

          <div class="part3 text-center m-auto">
            <vue-aos animation-class="fadeInUp animated">
              <div class="bordertext">
                <p class="edit b4">
                  เน้นที่การ<span
                    >แก้ไขพระราชบัญญัติภาษีสรรพสามิต พ.ศ. 2560</span
                  ><br />
                  มาตรา 153 เพื่อเปิดให้ประชาชนสามารถผลิตสุราในครัวเรือนได้<br />
                  แต่ถ้าประชาชนต้องการผลิตเพื่อการค้าต้องยื่นขออนุญาตและ<br />
                  การออกใบอนุญาตตามขั้นตอนตามที่กำหนดในกฎกระทรวง<br />
                </p>
                <div
                  class="circle d-flex justify-content-center align-items-center b4"
                >
                  1
                </div>
              </div>
            </vue-aos>

            <vue-aos animation-class="fadeInUp animated">
              <div class="bordertext">
                <p class="edit b4">
                  ยกเลิกการกำหนดคุณสมบัติในเรื่องกำลังการผลิต <br />
                  ทั้งกำลังแรงคน และกำลังเครื่องจักร
                </p>
                <div
                  class="circle d-flex justify-content-center align-items-center b4"
                >
                  2
                </div>
              </div>
            </vue-aos>

            <vue-aos animation-class="fadeInUp animated">
              <div class="bordertext">
                <p class="edit b4">
                  ไม่กำหนดทุนจดทะเบียนขั้นต่ำในการก่อตั้งบริษัทเบียร์
                </p>
                <div
                  class="circle d-flex justify-content-center align-items-center b4"
                >
                  3
                </div>
              </div>
            </vue-aos>
          </div>
        </div>
      </div>

      <div class="bookmark-bg container-fluid d-flex flex-column p-lg-5 p-sm-1">
        <div class="topic d-flex justify-content-center align-items-center">
          <h1>ถ้าพ.ร.บ.สุราก้าวหน้าปลดล็อกแล้ว</h1>
          <h3 class="nd">จะเกิดอะไรขึ้น<span class="qs"> ? </span></h3>
        </div>

        <div class="cardpart d-flex justify-content-center">
          <div class="cardd p-1">
            <div class="imgcontent">
              <img src="@/assets/pics/frame5/5.2/logo1.svg" alt="" />
            </div>
            <div
              class="datacontent d-flex justify-content-center align-items-center"
            >
              <p class="b6 text-center">
                มีการยกเลิกเกณฑ์ขั้นต่ำ <br />
                ด้านเงินทุนและการผลิต <br />
                ทำให้ประชาชนมีโอกาสทดลอง <br />
                และสร้างสรรค์คราฟต์เบียร์มากขึ้น <br />
                และสามารถเข้าแข่งขันใน <br />
                ตลาดเบียร์ได้อย่างเสรี
              </p>
            </div>
          </div>
          <div class="cardd p-1">
            <div class="imgcontent">
              <img src="@/assets/pics/frame5/5.2/logo2.svg" alt="" />
            </div>
            <div
              class="datacontent d-flex justify-content-center align-items-center"
            >
              <p class="b5 text-center">
                ส่งเสริมการเกษตรของไทย <br />
                ภาคธุรกิจที่เกี่ยวข้อง <br />
                และช่วยกระตุ้นเศรษฐกิจ <br />
                การท่องเที่ยว
              </p>
            </div>
          </div>
          <div class="cardd p-1">
            <div class="imgcontent">
              <img src="@/assets/pics/frame5/5.2/logo3.svg" alt="" />
            </div>
            <div
              class="datacontent d-flex justify-content-center align-items-center"
            >
              <p class="b5 text-center">
                ทำให้ให้ผู้บริโภคมีตัวเลือก <br />
                ในการบริโภค และได้ลิ้มลอง <br />
                ความหลากหลายทางรสชาติ <br />
                ในราคาที่จับต้องได้
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="more p-5">
        <div class="moretext p-4 m-auto">
          <div class="topic1 d-flex justify-content-center ">
            <img src="@/assets/pics/frame5/5.3/eyes2.svg" />
            <h4 class="m-2 mb-0 mt-0">
              ถึงแม้ว่า ส.ส. จะโหวตคว่ำร่าง พ.ร.บ. สุราก้าวหน้า
            </h4>
            <img src="@/assets/pics/frame5/5.3/eyes1.svg" />
          </div>
          <h4 class="text-center m-2 mb- mb-2 mt-0">
            ด้วยคะแนนไม่เห็นด้วย 196 ต่อ 194 เสียง
            และในวันเดียวกันนั้นรัฐบาลได้ประกาศบังคับใช้
          </h4>
          <h4 class="text-center mb-2">
            กฎกระทรวงการผลิตสุรา 2565 ซึ่งมีจุดประสงค์เดียวกับ พ.ร.บ.
            สุราก้าวหน้า แต่มีรายละเอียดปลีกย่อยที่แตกต่างกัน
          </h4>
        </div>

        <div class="moretext2 mt-5 p-2">
          <p class="b4 text-center">
            "แม้ว่าการผ่อนคลายเงื่อนไขการผลิตสุราของกฎกระทรวงถือเป็นโอกาส <br />
            ที่จะช่วยส่งเสริมความสามารถในการแข่งขันของผู้ผลิตสุรารายย่อย
            แต่กฎกระทรวงนี้จะพาให้คราฟต์เบียร์ไทย <br />
            มีทางเลือกในรสชาติมากกว่าและราคาจับต้องได้มากน้อยแค่ไหน
            คงต้องจับตาดูกันต่อไป..."
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Act1",
};
</script>

<style scoped>
.bookmark-bg {
  width: 100vw;
  height: 100%;
  overflow: hidden;
}
.bookmark-bg2 {
  overflow: hidden;
}
.bookmark-bg2,
.bookmark-bg3,
.bookmark-bg {
  background-color: #f8ef8f;
}
.bookmark-bg2,
.bookmark-bg {
  padding-top: 5rem;
}
.bookmark-bg3 {
  padding: 5rem;
}

.t-black {
  color: white;
  background-color: black;
  width: fit-content;
  padding: 0.5rem 1rem;
  transform: rotate(2deg);
}
.t-white {
  color: black;
  background-color: white;
  width: fit-content;
  padding: 0.5rem 1rem;
  border: 1px solid;
  transform: rotate(-2deg);
}
.maintext {
  color: #de5850;
  padding: 3rem;
}

.hand {
  width: 70%;
}
.part2 img {
  width: 3rem;
  margin: auto;
}
.part3 {
  width: 80%;
}
.bordertext {
  background-color: white;
  padding: 2rem;
  margin-bottom: 1rem;
  position: relative;
  border: 1px solid black;
}
.circle {
  position: absolute;
  border: 1px solid;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  top: 20px;
  left: 0;
  transform: translateX(-50%);
  background-color: white;
}
.text-color {
  background: #f4cc2d;
  width: fit-content;
}
span {
  background: #f8ef8f;
}
.edit {
  margin-bottom: 0;
}

/* 3if */
.topic {
  position: relative;
}
.topic h1 {
  padding: 1rem;
  background: white;
  border: 1px solid;
  transform: rotate(-2deg);
  width: fit-content;
}
.topic .nd {
  background: white;
  border: 1px solid;
  padding: 0.5rem 1rem;
  width: fit-content;
  position: absolute;
  bottom: 0;
  transform: translate(100%, 70%) rotate(3deg);
}
.nd span {
  color: white;
  background: white;
  -webkit-text-stroke: 1px black;
  font-size: 3rem;
}
.cardpart {
  margin: 5rem;
  height: 100%;
}
.cardd {
  width: 90%;
}
.imgcontent {
  height: 50%;
  object-fit: cover;
}
.imgcontent img {
  width: 100%;
  height: 100%;
}
.datacontent {
  border: 1px solid;
  height: 34%;
  margin: 3rem 1rem;
  background: white;
}
.datacontent p {
  margin-bottom: 0;
  font-size: 1.2rem;
}
/* more */
.more {
  background-color: #f8ef8f;
}
.moretext{
  background-color: white;
  width: fit-content;
}
.topic1 img {
  width: 3rem;
}
.moretext2 p {
  color: #de5850;
}

/* ipad */
@media (max-width: 821px) {
  .part2 h1 {
    font-size: 1.7rem;
  }
  .cardpart {
    margin: 3rem;
    flex-direction: column;
    align-items: center;
  }
  .datacontent {
    height: 43%;
    margin: 3rem 0.5rem;
    padding: 1.5rem;
  }
  .datacontent p {
    font-size: 20px;
  }
  .imgcontent {
    display: flex;
    justify-content: center;
  }
  .imgcontent img {
    width: 60%;
  }
  .topic1 img {
    width: 2rem;
  }
}
@media (max-width: 540px) {
  .maintext {
    padding: 2rem;
  }
  .maintext h1 {
    font-size: 1rem;
  }
  .part2 h1 {
    font-size: 1rem;
  }
  .part2 img {
    width: 2rem;
  }
  .edit {
    font-size: 0.7rem;
  }
  .circle {
    width: 2rem;
    height: 2rem;
    font-size: 0.7rem;
  }
  .topic h1 {
    font-size: 1rem;
  }
  .topic .nd {
    transform: translate(75%, 70%) rotate(3deg);
  }
  .topic .nd,
  .topic .qs {
    font-size: 1rem;
  }
  .datacontent p {
    font-size: 0.5rem;
  }
  .datacontent {
    height: 34%;
    margin: 1rem 1rem;
    padding: 1rem;
  }
  .t-black,
  .t-white {
    font-size: 1rem;
  }
  .topic1 img {
    width: 1rem;
  }
}
</style>
